export default __webpack_public_path__ + "static/fiveglobalspots-ora-f2f9b56ed60bd04f83f1d03a1311a1eb.jpg";